module.exports = "<what-is-solidary-list></what-is-solidary-list>\n<what-is-soliday-euro-footer\n  click-amplify=\"$ctrl.setShowMoreInfo({$event:$event})\">\n</what-is-soliday-euro-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryEuro.html
// module id = 2249
// module chunks = 0